const s = (r, e) => e.reduce((o, t) => {
  const a = t;
  return r[a] ? t === "category" ? { ...o, [t]: r[t].name } : { ...o, [t]: r[a] } : r.propertyValues && r.propertyValues[t] ? { ...o, [t]: r.propertyValues[t] } : { ...o, [t]: "" };
}, {}), l = (r, e, o) => {
  const t = e.reduce((a, n) => ({ ...a, [n]: r[n] ?? "" }), {});
  return o && (t.hasOwnProperty("totalCountItems") || (t.totalCountItems = ""), t.hasOwnProperty("totalPrice") || (t.totalPrice = "")), t;
};
export {
  s as mapProductToData,
  l as mapTotalForCalc
};
